<span class="{{badgeClass}} badge rounded-pill">
    {{label}}
</span>
